<div class="grid-container">
  <div class="grid-row grid-gap bg-accent-cool-lighter flex-justify-center">
    <div class="tablet:grid-col-9 grid-col-12 padding-x-4 margin-y-2 bg-white padding-bottom-30">
      <div class="margin-top-4 margin-bottom-2"><h1>Update Account Details</h1></div>
      <div class="custom-formly-form">
        <form [formGroup]="mainForm">
          <formly-form [model]="model" [fields]="fields" [options]="options" [form]="mainForm"></formly-form>
        </form>
      </div>

      <div class="grid-row tablet:padding-top-3 tablet:margin-top-neg-15 mobile:margin-bottom-3 mobile:margin-top-neg-3" *ngIf="user?.isGov">
        <div class="desktop:grid-col-7 tablet:grid-col-7 grid-col-12">
          <label class="usa-label">Sub-Tier
            <span class="text-normal">(Optional)</span></label>
          <sds-autocomplete [service]="subTierService" [(ngModel)]="subTierModel" [configuration]="subTierService.config" (ngModelChange)="subTierSelection=true"></sds-autocomplete>
        </div>
      </div>

      <div class="float-right-buttons">
        <button class="usa-button usa-button--base bg-base-lighter mobile:margin-bottom-2 padding-left-8 padding-right-8" (click)="onCancel.emit(null)">
          Cancel
        </button>

        <button class="usa-button padding-left-8 padding-right-8" (click)="submit()" [disabled]="!isFormValid">
          Update
        </button>
      </div>
    </div>
  </div>
</div>
